// Cell Restoration Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Emily", location: "FL", product: "Cell Restoration Bundle", time: "31 minutes ago" },
    { name: "Patrice", location: "AL", product: "Cell Restoration Bundle", time: "16 minutes ago" },
    { name: "Leticia", location: "CA", product: "Cell Restoration Bundle", time: "29 minutes ago" },
    { name: "Francisco", location: "TX", product: "Cell Restoration Bundle", time: "43 minutes ago" },
    { name: "Ariana", location: "AZ", product: "Cell Restoration Bundle", time: "58 minutes ago" },
    { name: "Marian", location: "TX", product: "Cell Restoration Bundle", time: "1 hour 13 minutes ago" },
    { name: "Tiffini", location: "TX", product: "Cell Restoration Bundle", time: "1 hour 28 minutes ago" },
    { name: "Carmen", location: "NM", product: "Cell Restoration Bundle", time: "1 hour 45 minutes ago" },
    { name: "Yamini", location: "CA", product: "Cell Restoration Bundle", time: "13 minutes ago" },
    { name: "Bertha", location: "IN", product: "Cell Restoration Bundle", time: "27 minutes ago" },
    { name: "Brad", location: "TX", product: "Cell Restoration Bundle", time: "42 minutes ago" },
    { name: "Dawn", location: "FL", product: "Cell Restoration Bundle", time: "58 minutes ago" },
    { name: "Benny", location: "FL", product: "Cell Restoration Bundle", time: "1 hour 15 minutes ago" },
    { name: "Olimpia", location: "TX", product: "Cell Restoration Bundle", time: "1 hour 33 minutes ago" },
    { name: "Shawn", location: "MD", product: "Cell Restoration Bundle", time: "1 hour 52 minutes ago" },
    { name: "Jason", location: "NJ", product: "Cell Restoration Bundle", time: "2 hours 12 minutes ago" },
    { name: "Francisca", location: "AZ", product: "Cell Restoration Bundle", time: "2 hours 33 minutes ago" },
    { name: "Luis", location: "CA", product: "Cell Restoration Bundle", time: "2 hours 55 minutes ago" },
    { name: "Lucio", location: "IL", product: "Cell Restoration Bundle", time: "3 hours 18 minutes ago" },
    { name: "Brad", location: "MO", product: "Cell Restoration Bundle", time: "3 hours 42 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Cell_Restoration_Bundle.png?v=1732605875" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
